/**
 * 服务端请求底层封装
 */

import axios, { AxiosRequestConfig, AxiosPromise, AxiosResponse, AxiosError } from "axios";
import {setLogin} from "@/common/script/auth";
import {isAPP, dylogout} from "@/appApi";
import {Toast} from "vant";

// import cookies from 'js-cookie';
// alert(cookies.get('sessionid'));
// cookies.set('sessionid', 'd6t9g3mt5ha9wpikzw910ta131ogzvyc'); // 18321674422
export default function base(propConfig: AxiosRequestConfig): AxiosPromise {
    // alert(JSON.stringify(cookies.get()));
    axios.defaults.withCredentials = true;

    const baseHeaders = {
        'X-Requested-With': 'XMLHttpRequest',
    }

    if (!propConfig.headers) {
        propConfig.headers = {}
    }
    propConfig.headers = Object.assign(propConfig.headers, baseHeaders);

    if (typeof propConfig.timeout !== 'number') {
        propConfig.timeout = 60000;
    }

    if (typeof propConfig.method !== 'string') {
        propConfig.method = 'GET';
    }

    return new Promise((resolve, reject) => {
        axios(propConfig).then((res: AxiosResponse) => {
            // 暂时屏蔽生产上用户未登录提示，是通过改方式提示
            if (res.data && res.data.status_code && res.data.status_code === 401) {
                handleHttpRequestError({
                    response: {
                        status: 401
                    }
                }, resolve, reject, propConfig);
            } else {
                handleHttpRequestEnter(res, resolve, reject);
            }
        }).catch((err: AxiosError) => {
            handleHttpRequestError(err, resolve, reject, propConfig);
            return;
        });
    });
}

/**
 * 请求正常处理
 */
function handleHttpRequestEnter(res: AxiosResponse, resolve: any, reject: any): void {
    // const status: any = res.data.errcode;
    resolve(res.data);
    console.log(reject);
}

/**
 * 请求错误处理
 */
function handleHttpRequestError(err: any, resolve: any, reject: any, propConfig: any = null): void {

    if (err.response.status === 401) {
        if (!isAPP()) {
            // if (process.env.NODE_ENV !== 'development') {
            //     setLogin(location.href);
            // } else {
            //     reject(err);
            // }
            setLogin(location.href);
        } else {
            if (window.appIsRegister) {
                dylogout();
            } else {
                window.addEventListener('appRegisterReady', () => {
                    dylogout();
                })
            }
            reject(err);
        }
    } else if (err.response.status === 400) {
        if (
          propConfig.url.indexOf('chinese_animation') === -1 &&
          propConfig.url.indexOf('/authuser/save_user_profile') === -1 // 个别接口不符合统一需求，先零时处理
        ) {
            Toast(err.response.data.message);
        }
        // 涉及到用户输入400,需要手动屏蔽报错界面
        reject(err);
    } else {
        Toast('系统开小差啦，稍后再试')
        reject(err);
    }
}